import { createContext, useContext } from 'react';

const PageTitleContext = createContext(null);

export const usePageTitle = () => useContext(PageTitleContext);

export default PageTitleContext;
